import { render, staticRenderFns } from "./FaceCompare.vue?vue&type=template&id=7d6977c2&scoped=true"
import script from "./FaceCompare.vue?vue&type=script&lang=js"
export * from "./FaceCompare.vue?vue&type=script&lang=js"
import style0 from "./FaceCompare.vue?vue&type=style&index=0&id=7d6977c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6977c2",
  null
  
)

export default component.exports